import type { TOC } from '@ember/component/template-only';
import fuiSearch from 'wise-fui-modules/modifiers/fui-search';

interface Signature {
  Element: HTMLInputElement;
  Args: {
    selected: string;
    settings?: Record<string, unknown>;
  };
}
const FuiSearchComponent: TOC<Signature> = <template>
  <div class='ui search' {{fuiSearch @settings}}>
    <div class='ui icon input'>
      <input value={{@selected}} type='text' class='prompt' ...attributes />
      <i class='search icon'></i>
    </div>
    <div class='results'></div>
  </div>
</template>;

export default FuiSearchComponent;
